module.exports = __webpack_public_path__ + "static/media/minivan_gray.ea73ee9c.svg";